import { css } from "@emotion/react";

import { theme } from "shared/lib/styles";

import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

export const responsiveStyles = ({
  $display = "flex",
  $hideOnSwap,
  $shouldSwap,
  $showIn = "mobileUp",
  $showOnSwap,
}: ResponsiveStyledProps) => css`
  /* =========================================
     Layer 1: Responsive Base
     ========================================= */

  display: ${$showIn === "mobileUp" || $showIn === "mobileOnly" || $showIn === "mobileAndTablet"
    ? $display
    : "none"};

  ${theme.breakpoints.up("tablet")} {
    ${($showIn === "tabletUp" || $showIn === "tabletOnly") &&
    css`
      display: ${$display};
    `}

    ${$showIn === "mobileOnly" &&
    css`
      display: none;
    `}
  }

  ${theme.breakpoints.up("desktop")} {
    ${$showIn === "desktopUp" &&
    css`
      display: ${$display};
    `}

    ${$showIn === "mobileAndTablet" &&
    css`
      display: none;
    `}
  }

  /* =========================================
     Layer 2: State Filter
     ========================================= */

  ${$showOnSwap === true &&
  !$shouldSwap &&
  css`
    display: none !important;
  `}

  ${$hideOnSwap === true &&
  $shouldSwap &&
  css`
    display: none !important;
  `}

  ${$hideOnSwap === "mobile" &&
  $shouldSwap &&
  css`
    ${theme.breakpoints.down("tablet")} {
      display: none !important;
    }
  `}

  ${$showOnSwap === "mobile" &&
  !$shouldSwap &&
  css`
    ${theme.breakpoints.down("tablet")} {
      display: none !important;
    }
  `}

  ${$hideOnSwap === "mobileAndTablet" &&
  $shouldSwap &&
  css`
    ${theme.breakpoints.down("desktop")} {
      display: none !important;
    }
  `}

  ${$showOnSwap === "mobileAndTablet" &&
  !$shouldSwap &&
  css`
    ${theme.breakpoints.down("desktop")} {
      display: none !important;
    }
  `}

  ${$hideOnSwap === "tablet" &&
  $shouldSwap &&
  css`
    ${theme.breakpoints.up("tablet")} {
      ${theme.breakpoints.down("desktop")} {
        display: none !important;
      }
    }
  `}

  ${$showOnSwap === "tablet" &&
  !$shouldSwap &&
  css`
    ${theme.breakpoints.up("tablet")} {
      ${theme.breakpoints.down("desktop")} {
        display: none !important;
      }
    }
  `}

  ${$showOnSwap === "desktop" &&
  !$shouldSwap &&
  css`
    ${theme.breakpoints.up("desktop")} {
      display: none !important;
    }
  `}

  ${$hideOnSwap === "desktop" &&
  $shouldSwap &&
  css`
    ${theme.breakpoints.up("desktop")} {
      display: none !important;
    }
  `}
`;
